import { Injectable, OnDestroy } from '@angular/core'
import { Observable, Subject, takeUntil } from 'rxjs'
import { AgendaSocketService } from './agenda-socket.service'
import { LockedTimeSlotService } from '../../../../services/locked-time-slot.service'
import { AppointmentCancelledEvent, AppointmentCreatedEvent, AppointmentTransferredEvent, BlockedSlotsUpdatedEvent } from './agenda-calendar.models'
import { LockedTimeSlotType } from '../../../appointment-calendar/interface/time-slot'

@Injectable()
export class ScheduleSocketService implements OnDestroy {
  private destroy$ = new Subject<void>()

  readonly appointmentTransferred$: Observable<AppointmentTransferredEvent>
  readonly appointmentCreated$: Observable<AppointmentCreatedEvent>
  readonly appointmentCancelled$: Observable<AppointmentCancelledEvent>
  readonly lockedTimeSlotsUpdated$: Observable<LockedTimeSlotType[]>
  readonly unlockedTimeSlotsUpdated$: Observable<LockedTimeSlotType[]>
  readonly blockedSlotsUpdated$: Observable<BlockedSlotsUpdatedEvent[]>

  constructor(
    private agendaSocket: AgendaSocketService,
    private lockedTimeSlotService: LockedTimeSlotService,
  ) {
    this.appointmentTransferred$ = this.agendaSocket
      .onAppointmentTransferred()
      .pipe(takeUntil(this.destroy$))

    this.appointmentCreated$ = this.agendaSocket
      .onAppointmentCreated()
      .pipe(takeUntil(this.destroy$))

    this.appointmentCancelled$ = this.agendaSocket
      .onAppointmentCancelled()
      .pipe(takeUntil(this.destroy$))

    this.blockedSlotsUpdated$ = this.agendaSocket
      .onBlockedSlotsUpdated()
      .pipe(takeUntil(this.destroy$))

    this.lockedTimeSlotsUpdated$ = this.lockedTimeSlotService
      .listen<LockedTimeSlotType[]>('lockedTimeSlotsUpdated')
      .pipe(takeUntil(this.destroy$))

    this.unlockedTimeSlotsUpdated$ = this.lockedTimeSlotService
      .listen<LockedTimeSlotType[]>('unlockedTimeSlotsUpdated')
      .pipe(takeUntil(this.destroy$))
  }

  joinSchedule(scheduleIds: number[]): void {
    this.agendaSocket.joinAgendaRoom(scheduleIds)
    for (const id of scheduleIds) {
      this.lockedTimeSlotService.emit('addClientToScheduleLockedTimeSlotsRoom', id)
    }
  }

  leaveSchedule(scheduleIds: number[]): void {
    this.agendaSocket.leaveAgendaRoom(scheduleIds)
    for (const id of scheduleIds) {
      this.lockedTimeSlotService.emit('removeClientToScheduleLockedTimeSlotsRoom', id)
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
